import { render, staticRenderFns } from "./LaboratoryAppointmentTable.vue?vue&type=template&id=3af7974e&"
import script from "./LaboratoryAppointmentTable.vue?vue&type=script&lang=js&"
export * from "./LaboratoryAppointmentTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports